import { toast } from 'react-toastify';
import { LABEL_MESSAGES } from './labelMessages';

export const handleErrorRequest = (response) => {
  if (!response) {
    return toast.error('Não foi possível realizar a operação!');
  }

  // Valida retorno de autorização
  if (response?.response?.status === 403) {
    if (response.response.data.resposta) {
      response.response.data.resposta.map((retorno) => {
        if (retorno) {
          toast.error(`${LABEL_MESSAGES[retorno.key] ?? retorno.key} - ${retorno.message}`);
        }
        return null;
      });
    }

    return null;
  }

  if (response?.data?.resposta?.[0]?.key) {
    const errosArray = [];

    response.data.resposta.map((resposta) => {
      errosArray.push(resposta.key);

      toast.error(`${LABEL_MESSAGES[resposta.key] ?? resposta.key} - ${resposta.message}`);
      return null;
    });

    return errosArray;
  } else if (response?.data?.resposta?.[0]?.message) {
    response.data.resposta.map((resposta) => {
      const errosArray = [];
      errosArray.push(resposta.message);

      toast.error(`${resposta.message}`);
      return null;
    });
  } else {
    toast.error('Não foi possível realizar a operação!');
  }
  return [];
};
